import { API_BASE_URL } from "@/consts";
import axios from "axios";
import { snippetApiToken } from "@/composables/useSnippetApiToken";

const BASE = `${API_BASE_URL}/snippet-analytics/engagement`;

const get = async (path, params) => {
  try {
    const { data } = await axios.get(`${BASE}${path}`, {
      params,
      headers: { Authorization: `Bearer ${snippetApiToken()}` },
    });
    return data.success ? data.data : null;
  } catch (error) {
    console.error(`Snippet engagement request failed: ${path}`, error);
    return null;
  }
};

export const fetchKpis = (params) => get("/kpis", params);
export const fetchCta = (params) => get("/cta", params);
export const fetchFunnel = (params) => get("/funnel", params);
export const fetchEpisodes = (params) => get("/episodes", params);
export const fetchDaily = (params) => get("/daily", params);
